// src/App.jsx
import React, { useState } from "react";
import FiscalYears from "./pages/FiscalYears";
import Users from "./pages/Users";
import Events from "./pages/Events";

export default function App() {
  const [page, setPage] = useState("fiscalYears");

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <nav className="flex justify-center gap-4 mb-6">
        <button
          onClick={() => setPage("fiscalYears")}
          className={`px-4 py-2 rounded ${
            page === "fiscalYears" ? "bg-blue-600 text-white" : "bg-gray-200"
          }`}
        >
          سال‌های مالی
        </button>
        <button
          onClick={() => setPage("users")}
          className={`px-4 py-2 rounded ${
            page === "users" ? "bg-blue-600 text-white" : "bg-gray-200"
          }`}
        >
          کاربران
        </button>
        <button
          onClick={() => setPage("events")}
          className={`px-4 py-2 rounded ${
            page === "events" ? "bg-blue-600 text-white" : "bg-gray-200"
          }`}
        >
          تراکنش‌ها
        </button>
      </nav>

      <main className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow">
        {page === "fiscalYears" && <FiscalYears />}
        {page === "users" && <Users />}
        {page === "events" && <Events />}
      </main>
    </div>
  );
}
